import { constants } from "../../misc/constants";
import Scenario2 from "./Scenario2";
import { TransformUIConfig } from "../../components/ui/TransformUI";
import MedsurgBaseScenarioPart from "../MedsurgBaseScenarioPart";
import { Window508Type } from "../MedsurgBaseScenario";

export default class Scenario2Part2 extends MedsurgBaseScenarioPart {

	chapterIds = {
		chapterCinematic1: 'medsurg-cinematic-2-1',
        chapterCinematic13: 'medsurg-cinematic-2-13',
        chapterCinematic15: 'medsurg-cinematic-2-15',
        chapterCinematic16: 'medsurg-cinematic-2-16',
        chapterCinematic17: 'medsurg-cinematic-2-17',
        chapterCinematic18: 'medsurg-cinematic-2-18',
        chapterCinematic19: 'medsurg-cinematic-2-19',
        chapterCinematic20: 'medsurg-cinematic-2-20',
		chapterCinematic21: 'medsurg-cinematic-2-21',
		//NEED SIGN ANIMS (4 ANIMATIONS)
		chapterCinematic91: 'medsurg-cinematic-2-91',
        chapterCinematic92: 'medsurg-cinematic-2-92',
        chapterCinematic89: 'medsurg-cinematic-2-89',
		chapterCinematic90: 'medsurg-cinematic-2-90',
		//NEED FAIL ANIMS (4 ANIMATIONS)
		chapterCinematic96: 'medsurg-cinematic-2-96',
        chapterCinematic97: 'medsurg-cinematic-2-97',
        chapterCinematic94: 'medsurg-cinematic-2-94',
		chapterCinematic95: 'medsurg-cinematic-2-95',
		
	}

	constructor(scenario: Scenario2, private onDone: () => void){
		super(scenario);
	}

	private PrInstanceID: string;
	private TalkInstanceID1: string;
	private ActionInstanceID1: string;
	private RememberDisplayed: boolean = false;
	private ActionInstanceID2: string;
	private MoveInstanceID: string;

	private Talk1: boolean = false;
	private Talk2: boolean = false;
	private Talk3: boolean = false;
	private Talk4: boolean = false;
	private Talk5: boolean = false;
	private Talk6: boolean = false;
	private Action1: boolean = false;
	private Action2: boolean = false;
	private Action3: boolean = false;
	private Action4: boolean = false;
	private Action5: boolean = false;
	private Action6: boolean = false;
	private Action11: boolean = false;
	private Action12: boolean = false;
	private Action13: boolean = false;
	private Action14: boolean = false;
	private Action15: boolean = false;
	private Action21: boolean = false;
	private Action22: boolean = false;
	private Action23: boolean = false;
	private Action24: boolean = false;
	private Action25: boolean = false;

	private TalkCount: number = 0;
	private OldTalkCount: number = 0;
	private ActionCount: number = 0;
	private OldActionCount: number = 0;
	private PAbool: boolean = false;
	private PObool: boolean = false;
	private PA2bool: boolean = false;
	
	private avatar1: boolean = false;
	private avatar2: boolean = false;
	private avatar3: boolean = false;
	private avatar4: boolean = false;


	public get partId(): string {
		return constants.scenarios.scenario2.parts.level2Part2.id;
	}

	public get videoUrl(): string[] {
		//return ['./assets/videos/scenario2/video3' + this.scenario.avatarIndx + '.mp4'];
		return ['./assets/videos/scenario2/video30.mp4'];
	}

	public start() {
		const context = this;
		if(this.scenario.avatarIndx === 0) {
			this.avatar1 = true;
			this.avatar2 = false;
			this.avatar3 = false;
			this.avatar4 = false;
		}
		else if(this.scenario.avatarIndx === 1) {
			this.avatar2 = true;
			this.avatar1 = false;
			this.avatar3 = false;
			this.avatar4 = false;
		}
		else if(this.scenario.avatarIndx === 2) {
			this.avatar3 = true;
			this.avatar2 = false;
			this.avatar1 = false;
			this.avatar4 = false;
		}
		else if(this.scenario.avatarIndx === 3) {
			this.avatar4 = true;
			this.avatar2 = false;
			this.avatar3 = false;
			this.avatar1 = false;
		}
		this.RememberDisplayed = false;

		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changVitalsID, {
			title: 'Vitals - On Admission'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changVitalsID, {
			list: '<li>Temperature: 98.6</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changVitalsID, {
			list: '<li>Pulse: 78</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changVitalsID, {
			list: '<li>Respirations: 20</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changVitalsID, {
			list: '<li>Blood Pressure: 175/80</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changVitalsID, {
			list: '<li>Oxygen Saturation: 99% room air </li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changVitalsID, {
			title: 'Vitals - 09:00',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
			visit: context.scenario.visit1,
			lineBreak: true,
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changBasicID, {
			title: 'Patient Information',
			description: '<ul style=\"list-style-type:square\"><li>Avery Chang, a 45-year-old Asian female patient, has undergone an arteriovenous fistula (AVF) procedure (left arm) and insertion of a tunnel dialysis catheter (right side).</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changBasicID, {
			title: 'Patient History',
			description: '<ul style=\"list-style-type:square\"><li>Chronic renal insufficiency</li><li>Hypertension</li><li>GI issues are within normal limits</li><li>Diabetes Type II</li><li>Asian</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changBasicID, {
			title: 'Active Medications',
			description: '<ul style=\"list-style-type:square\"><li>Doxazosin tab, 4mg</li><li>Ramipril cap, 5mg</li><li>Amlodipine tab, 5mg</li><li>Hydrochlorothiazide, 25mg</li><li>Metformin, 500mg</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changBasicID, {
			title: 'Providers Orders',
			description: '<ul style=\"list-style-type:square\"><li>No venipuncture, BP, lab work, IV, heavy lifting, to be taken to patient’s left arm</li><li>Check bruit every 3-4 hours</li><li>Hydromorphone 1 mg IV push every 3 hours (PRN)</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changBasicID, {
			title: 'Dietary Restrictions',
			description: '<ul style=\"list-style-type:square\"><li>Fluid restriction (1500 mL/day)</li><li>Low sodium (2 g diet)</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changBasicID, {
			title: 'Other Observations',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changBasicID, {
			title: 'Post-Op Information',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});

		context.segment1Step1IntroWalking();
	}

	private segment1Step1IntroWalking() {
		var context = this;
		this.scenario.destroyAllUIInstances();
		context.scenario.displayHeader();
		this.scenario.playAmbientLoop(this.scenario.audioHall);
		this.playVideoChapter(this.chapterIds.chapterCinematic1, () => {
			context.segment1Step2ContinueRoom1();
		});
    }

	private segment1Step4Remember() {
		var context = this;
		this.scenario.update508Window(Window508Type.Remember);
		this.scenario.displayRemember(() => {
			this.scenario.update508Window(Window508Type.Main);
			this.RememberDisplayed = true;
			context.scenario.destroyAllUIInstances();
			// context.skipPart();
		});
	}
	//use when skipping part for testing
	private skipPart() {
		var context = this;
		context.scenario.hideFooter();
        this.scenario.displayModalPop(
			null,
            'Skipping to part 3',
            () => {
                context.scenario.destroyAllUIInstances();
                    context.segment1StepFinal();
            }
        );
	}

    private segment1Step2ContinueRoom1() {
		this.scenario.destroyAllUIInstances();
        var context = this;
        context.scenario.gameManager.environment.blurFadeIn();
        this.scenario.displayModalPop(
			null,
            'You have a new patient to visit in room 5',
            () => {
				this.scenario.stopAmbientLoop();
				this.scenario.playAmbientLoop(this.scenario.audioRoom);
				context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
				this.playVideoChapter(this.chapterIds.chapterCinematic13, () => {}, true);
                context.PreloadUis();
				if(this.RememberDisplayed === false) {
					context.segment1Step4Remember();
				}
				context.scenario.displayFooter(() => this.PrInstanceID, () => this.TalkInstanceID1, () => this.ActionInstanceID1, '6', '1', false, false);
				context.TalkCount = 6;
				context.ActionCount = 1;
				context.getFooterCounts();
            }
        );
    }

	private segment1Part5Debrief() {
		var context = this;
		context.scenario.displayDebrief(7850, () => {
			localStorage.setItem('ignoreResumePopup', 'true');
			window.location.reload();
		}, () => {
			context.segment1StepFinal();
		});
	}

	private segment1StepFinal() {
        var context = this;
        context.scenario.destroyAllUIInstances();
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changVitalsID, {
			title: 'Vitals - 12:00'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
			visit: context.scenario.visit3,
			lineBreak: true
		});
    	context.partEnd();
    }

	private partEnd() {
        var context = this;
		this.scenario.stopAmbientLoop();
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;
		context.scenario.saveScore();
		context.onDone();
	}

    public PreloadUis(shouldHidePatientRecord?: boolean) {
        var context = this;
        this.PrInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.PatientRecordUI, {
            top: [
				{
					description: 'Name: Avery Chang'
				},
				{
					description: 'Room: #5'
				},
				{
					description: 'Age: 45'
				},
				{
					description: 'Sex: Female'
				}
			],
			basic: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).changBasicID),
			nurses: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).changNursesID),
			lab: [
				{
					title: 'Test Name',
					description1: 'BUN',
					description2: '<div style="color: red" aria-label="123 m g over d L. up"> 123 mg/dL <span style="float: right">&#129137;</span></div>',
					description3: '<div aria-label="8 to 26">8 - 26</div>'
				},
				{
					title: 'Results',
					description1: 'Creatine',
					description2: '<div style="color: red" aria-label="8.1 m g over d L. up"> 8.1 mg/dL <span style="float: right">&#129137;</span></div>', // 7 change to 9 for down arrow
					description3: '<div aria-label="0.7 to 1.2">0.7 - 1.2</div>'
				},
				{
					title: 'Normal Range',
					description1: 'Sodium',
					description2: '<div aria-label="144 m m o l over L">144 mmol/L</div>',
					description3: '<div aria-label="136 to 145">136 - 145</div>'
				},
				{
					description1: 'Potassium',
					description2: '<div style="color: red" aria-label="5.4 m m o l over L. up"> 5.4 mmol/L <span style="float: right">&#129137;</span></div>',
					description3: '<div aria-label="3.5 to 5.1">3.5 - 5.1</div>'
				},
				{
					description1: 'Chloride',
					description2: '<div aria-label="100 m m o l over L">100 mmol/L</div>',
					description3: '<div aria-label="98 to 107">98 - 107</div>'
				},
				{
					description1: 'Glucose',
					description2: '<div style="color: red" aria-label="129 m g over d L. up"> 129 mg/dL <span style="float: right">&#129137;</span></div>',
					description3: '<div aria-label="74 to 106">74 - 106</div>'
				},
				{
					description1: 'HGB',
					description2: '<div style="color: red" aria-label="12 g over d L. down"> 12 g/dL <span style="float: right">&#129139;</span></div>',
					description3: '<div aria-label="13.5 to 17.9">13.5 - 17.9</div>'
				},
				{
					description1: 'HCT',
					description2: '<div style="color: red" aria-label="36.2 g over d L. down"> 36.2 g/dL <span style="float: right">&#129139;</span></div>',
					description3: '<div aria-label="41 to 54">41 - 54</div>'
				}
			],
			vitals: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).changVitalsID),
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.Remember);
				}, 500);
				this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
				// if(this.RememberDisplayed === false) {
				// 	context.segment1Step4Remember();
				// }
			} 
		});

		if(shouldHidePatientRecord) {
			this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
		} else {
			setTimeout(() => {
				context.scenario.update508Window(Window508Type.PatientRecord);
			}, 500);
		}

		(this.scenario as Scenario2).PrChangID = this.PrInstanceID;

		context.TalkInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Talk',
			talks: [
				{
					toppx: '50px',
					titletext: 'How are you feeling?',
					onClicked: () => {
						this.segment1TalkFeeling();
					},
					disable: () => this.Talk1
				},
				{
					toppx: '150px',
					titletext: 'Can you describe your pain?',
					onClicked: () => {
						this.segment1TalkDescribe();
					},
					disable: () => this.Talk2
				},
				{
					toppx: '250px',
					titletext: 'On a scale of 0-10, can you rate your pain?',
					onClicked: () => {
						this.segment1TalkRate();
					},
					disable: () => this.Talk3
				},
				{
					toppx: '350px',
					titletext: 'Do you know what day it is?',
					onClicked: () => {
						this.segment1TalkDay();
					},
					disable: () => this.Talk4
				},
				{
					toppx: '450px',
					titletext: "Do you know why you're here today?",
					onClicked: () => {
						this.segment1TalkWhy();
					},
					disable: () => this.Talk5
				},
				{
					toppx: '550px',
					titletext: 'Would you like something for the pain?',
					onClicked: () => {
						this.segment1TalkForPain();
					},
					disable: () => this.Talk6
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);

		this.ActionInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Action',
			talks: [
				{
					toppx: '50px',
					titletext: 'Take Vitals',
					onClicked: () => {
						this.segment1ActionVitals();
					},
					disable: () => this.Action1
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
	}

	private segment1ActionVitals() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID2 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Take Vitals',
			talks: [
				{
					toppx: '50px',
					titletext: 'Temperature',
					onClicked: () => {
						context.segment1ActionTemperature();
					},
					disable: () => this.Action11
				},
				{
					toppx: '150px',
					titletext: 'Blood Pressure',
					onClicked: () => {
						context.segment1ActionBloodPressure();
					},
					disable: () => this.Action12
				},
				{
					toppx: '250px',
					titletext: 'Pulse',
					onClicked: () => {
						context.segment1ActionPulse();
					},
					disable: () => this.Action13
				},
				{
					toppx: '350px',
					titletext: 'Respirations',
					onClicked: () => {
						context.segment1ActionRespirations();
					},
					disable: () => this.Action14
				},
				{
					toppx: '450px',
					titletext: 'O2 Sat Level',
					onClicked: () => {
						context.segment1ActionSatLevel();
					},
					disable: () => this.Action15
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment1TalkFeeling() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '70px',
			loadQuiz: true,
			scenario: this,
			titletext: 'How are you feeling?',
			isTalks: true,
			extBottom: true,
			extText: "I'm really groggy and feeling a bit of discomfort.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PObool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
						title: context.scenario.patientObservation,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PObool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientObservation)
					}
				}
				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk1 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 6,
					quiztop: '5px',
					maxPoints: 150,
					talktext1: 'Patient Observation',
					talktext2: 'General',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'No active problems',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Groggy',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Discomfort',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Nausea',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Headache',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: "Doesn't feel right",
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic16, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic13, () => {}, true);
		});
	}

	private segment1TalkDescribe() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '170px',
			loadQuiz: true,
			titletext: 'Can you describe your pain?',
			scenario: this,
			isTalks: true,
			extBottom: true,
			extText: "I feel some soreness in my left arm",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}
				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk2 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 5,
					quiztop: '5px',
					maxPoints: 75,
					talktext1: 'Patient Assessment',
					talktext2: 'Pain Description',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Sore',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Stabbing',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Burning',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Discomfort',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Unable to describe',
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 5,
					prequizheight: 5,
					quiztop: '520px',
					maxPoints: 75,
					talktext1: 'Patient Assessment',
					talktext2: 'Pain Location',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Abdominal',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Head',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Arm',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Back',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Unable to describe',
							onClicked: () => {
							},
						},
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic17, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic13, () => {}, true);
		});
	}

	private segment1TalkRate() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '270px',
			loadQuiz: true,
			titletext: 'On a scale of 0-10, can you rate your pain?',
			scenario: this,
			isTalks: true,
			isPainScale: true,
			painScaleMaxPoints: 100,
			painScaleCorrect: 6,
			extBottom: true,
			extText: "About a 6.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				this.scenario.evaluateScoreForPainScale(updatedConfig);
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
					header: 'Pain Scale',
					list: '<li>'+updatedConfig.painAssessment+'</li>',
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
				this.Talk3 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic18, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic13, () => {}, true);
		});
	}

	private segment1TalkDay() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			scenario: this,
			toptitle: 'Talk',
			toppx: '370px',
			loadQuiz: true,
			titletext: 'Do you know what day it is?',
			isTalks: true,
			extBottom: true,
			extText: "Today is Tuesday.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PObool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
						title: context.scenario.patientObservation,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PObool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientObservation)
					}
				}
				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk4 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 5,
					quiztop: '5px',
					maxPoints: 300,
					talktext1: 'Patient Observation',
					talktext2: 'Mental Status',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Alert',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Oriented',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Confused',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Incoherent',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'No response',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);

		context.scenario.displayModalPop(
			null,
            'Today is Tuesday.',
            () => {
				context.scenario.update508Window(Window508Type.TransformUI);
                context.scenario.endModalPop();
				this.playVideoChapter(this.chapterIds.chapterCinematic19, () => {
					this.playVideoChapter(this.chapterIds.chapterCinematic13, () => {}, true);
				});
            }
        );
	}

	private segment1TalkWhy() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			scenario: this,
			toptitle: 'Talk',
			toppx: '470px',
			loadQuiz: true,
			titletext: "Do you know why you're here today",
			isTalks: true,
			extBottom: true,
			extText: "For my procedure - AVF and catheter insertion.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PObool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
						title: context.scenario.patientObservation,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PObool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientObservation)
					}
				}
				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk5 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 5,
					quiztop: '5px',
					maxPoints: 300,
					talktext1: 'Patient Observations',
					talktext2: 'Mental status',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Alert',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Oriented',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Confused',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Incoherent',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'No response',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic20, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic13, () => {}, true);
		});
	}

	private segment1TalkForPain() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			scenario: this,
			toptitle: 'Talk',
			toppx: '570px',
			loadQuiz: true,
			titletext: 'Would you like something for the pain?',
			isTalks: true,
			extBottom: true,
			extText: "Yes, please.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
					title: 'Medicine Administered',
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.medicineAdministered)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk6 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 2,
					quiztop: '5px',
					maxPoints: 100,
					talktext1: 'Medication Administered',
					talktext2: ' ',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Yes',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -500px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic21, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic13, () => {}, true);
		});
	}

	private segment1ActionTemperature() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			scenario: this,
			toptitle: 'Action',
			toppx: '70px',
			loadQuiz: true,
			titletext: 'Temperature',
			vitaltext: '98.7',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_temp.png',
			onSubmit: () => {
				this.Action11 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changVitalsID, {
					list: '<li>Temperature : 98.7</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionBloodPressure() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			scenario: this,
			toptitle: 'Action',
			toppx: '170px',
			loadQuiz: true,
			titletext: 'Blood Pressure',
			vitaltext: '156/60',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_bp.png',
			onSubmit: () => {
				this.Action12 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changVitalsID, {
					list: '<li>Blood Pressure : 156/60</li>',
				})
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.updateScore(100);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionPulse() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			scenario: this,
			toppx: '270px',
			loadQuiz: true,
			titletext: 'Pulse',
			vitaltext: '80',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_pulse.png',
			onSubmit: () => {
				this.Action13 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changVitalsID, {
					list: '<li>Pulse : 80</li>',
				})
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.updateScore(100);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionRespirations() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			scenario: this,
			toppx: '370px',
			loadQuiz: true,
			titletext: 'Respirations',
			vitaltext: '20',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_respiration.png',
			onSubmit: () => {
				this.Action14 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changVitalsID, {
					list: '<li>Respirations : 20</li>',
				})
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.updateScore(100);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionSatLevel() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			scenario: this,
			toppx: '470px',
			loadQuiz: true,
			titletext: 'O2 Sat Level',
			vitaltext: '97%',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_o2.png',
			onSubmit: () => {
				this.Action15 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changVitalsID, {
					list: '<li>02 Sat Level : 97%</li>',
				})
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.updateScore(100);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.segment2PreloadUis();
		}
		else if(this.TalkCount === 0 && this.ActionCount !== 0) {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		}
		else if(this.TalkCount !== 0 && this.ActionCount === 0) {
			context.scenario.updateFooter(this.TalkCount.toString(), '0', false, true);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), false, false)
		};
	}

	private checkIfSubMenu() {
		var context = this;
		if(this.Action11 === true && this.Action12 === true && this.Action13 === true && this.Action14 === true && this.Action15 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			this.ActionCount = this.OldActionCount - 1;
			this.Action1 = true;
		};
		context.getFooterCounts();
	}

	private segment2PreloadUis() {
        var context = this;
		context.scenario.gameManager.UiManager.updateUIInstance(this.ActionInstanceID1, {
			talks: [
				{
					toppx: '50px',
					titletext: 'Assess Patient: Check Patency of AVF',
					onClicked: () => {
						this.segment1ActionAVF();
					},
					disable: () => this.Action2
				},
				{
					toppx: '150px',
					titletext: 'Assess Patient',
					onClicked: () => {
						this.segment1ActionAssess();
					},
					disable: () => this.Action3
				},
				{
					toppx: '250px',
					titletext: 'Tunnel Dialysis Catheter Condition',
					onClicked: () => {
						this.segment1ActionCatheter();
					},
					disable: () => this.Action4
				},
				{
					toppx: '350px',
					titletext: 'Give Directions',
					onClicked: () => {
						this.segment1ActionDirection();
					},
					disable: () => this.Action5
				},
				{
					toppx: '450px',
					titletext: 'Place No BP or IV sign',
					onClicked: () => {
						this.segment1ActionSign();
					},
					disable: () => this.Action6
				}
			]
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);

		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
			visit: context.scenario.visit2,
			lineBreak: true
		});
		context.ActionCount = 9;
		context.getFooterCounts2();
	}

	private segment1ActionAVF() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Actions',
			scenario: this,
			toppx: '70px',
			loadQuiz: true,
			titletext: 'Assess Patient: Check Patency of AVF',
			isTalks: true,
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PA2bool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PA2bool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action2 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
				{
					quizheight: 2,
					quiztop: '5px',
					maxPoints: 500,
					talktext1: 'Patient Assessment',
					talktext2: 'Bruit',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Present',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Absent',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);

		context.scenario.displayModalPop(
			null,
            'Bruit is present.',
            () => {
                context.scenario.endModalPop();
				context.scenario.update508Window(Window508Type.TransformUI);
            }
        );
	}

	private segment1ActionAssess() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID2 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Assess Patient',
			talks: [
				{
					toppx: '50px',
					titletext: 'AVF Surgical Dressing: Dressing',
					onClicked: () => {
						context.segment2ActionDressing();
					},
					disable: () => this.Action21
				},
				{
					toppx: '150px',
					titletext: 'AVF Surgical Dressing: Left Hand',
					onClicked: () => {
						context.segment2ActionHand();
					},
					disable: () => this.Action22
				},
				{
					toppx: '250px',
					titletext: 'AVF Surgical Dressing: Capillary Refill',
					onClicked: () => {
						context.segment2ActionRefill();
					},
					disable: () => this.Action23
				},
				{
					toppx: '350px',
					titletext: 'Tunnel Dialysis Catheter Dressing: Dressing',
					onClicked: () => {
						context.segment2ActionCatheter();
					},
					disable: () => this.Action24
				},
				{
					toppx: '450px',
					titletext: 'Tunnel Dialysis Catheter Dressing: Skin',
					onClicked: () => {
						context.segment2ActionSkin();
					},
					disable: () => this.Action25
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment1ActionCatheter() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '270px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Tunnel Dialysis Catheter Condition',
			isTalks: true,
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
					title: context.scenario.tdCatheter,
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
							header: 'Condition - Tunnel Dialysis Catheter Condition',
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.tdCatheter)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action4 = true;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 750,
					talktext1: 'Tunnel Dialysis Catheter',
					talktext2: 'Condition',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Intact',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Loose',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Clamped',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Unclamped',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionDirection() {
		var context = this;
		var selectFail = false;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '370px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Give Directions',
			isTalks: true,
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(!selectFail) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
						title: context.scenario.advisePatient,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					for(var i = 0; i < updatedConfig.quiz.length; i++) {
						var quiz = updatedConfig.quiz[i];
						for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
							var talk = quiz.talks[quiz.selectedTalkIndices[p]];
							this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
								header: 'Condition - Tunnel Dialysis Catheter Condition',
								list: '<li>'+talk.buttontext+'</li>',
							}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.advisePatient)
						}
					}
					this.scenario.evaluateScoreForTalk(updatedConfig);
					this.Action5 = true;
					this.ActionCount = this.OldActionCount - 1;
					setTimeout(() => {
						context.scenario.update508Window(Window508Type.TalkActionsUI);
					}, 1000);
					context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
					context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
					context.getFooterCounts2();
				} else if(selectFail) {
					context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
					setTimeout(() => {
						context.scenario.update508Window(Window508Type.TalkActionsUI);
					}, 1000);
					context.segment2ActionFail();
				}
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 750,
					talktext1: 'Advise Patient',
					talktext2: ' ',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'No blood pressure or any lab work can be taken from the left arm.',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No heavy lifting done with the left arm.',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Do light exercise with stress ball.',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Lift small weights with the left arm.',
							onClicked: () => {
								if(!selectFail) {
									selectFail = true;
								} else selectFail = false;
							},
						}
					],
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionSign() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '470px',
			loadQuiz: true,
			titletext: 'Place No BP or IV sign',
			scenario: this,
			isTalks: true,
			onSubmit: () => {
				this.Action6 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.updateScore(250);
				//NEED SIGN ANIM2, CHANGE CHAPTERCINEMATICS BELOW TO EACH PLAYER CHARACTER LOOP
				if(this.avatar1) {
					this.playVideoChapter(this.chapterIds.chapterCinematic91, () => {
						this.playVideoChapter(this.chapterIds.chapterCinematic13, () => {}, true);
					});
				} else if (this.avatar2) {
					this.playVideoChapter(this.chapterIds.chapterCinematic92, () => {
						this.playVideoChapter(this.chapterIds.chapterCinematic13, () => {}, true);
					});
				} else if (this.avatar3) {
					this.playVideoChapter(this.chapterIds.chapterCinematic89, () => {
						this.playVideoChapter(this.chapterIds.chapterCinematic13, () => {}, true);
					});
				} else if (this.avatar4) {
					this.playVideoChapter(this.chapterIds.chapterCinematic90, () => {
						this.playVideoChapter(this.chapterIds.chapterCinematic13, () => {}, true);
					});
				}
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionDressing() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '70px',
			loadQuiz: true,
			titletext: 'AVF Surgical Dressing: Dressing',
			isTalks: true,
			scenario: this,
			extTop: true,
			extImg: 't9',
			extText: 'Dressing is clean, dry, and intact',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PA2bool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PA2bool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action21 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 1000,
					talktext1: 'Patient Assessment',
					talktext2: 'Dressing',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Clean',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Dry',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Intact',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Bleeding present',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionHand() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '170px',
			loadQuiz: true,
			titletext: 'AVF Surgical Dressing: Left Hand',
			isTalks: true,
			extTop: true,
			scenario: this,
			extImg: 't9',
			extText: 'Skin on the left hand is warm. Movement and sensation are present. Skin color is normal for ethnic group',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PA2bool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PA2bool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
					}
				}

				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action22 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 6,
					quiztop: '5px',
					maxPoints: 1000,
					talktext1: 'Patient Assessment',
					talktext2: 'Left Hand',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Warm',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Cold',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Movement present',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Sensation present',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Normal for ethnic group',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Pale',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionRefill() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '270px',
			loadQuiz: true,
			titletext: 'AVF Surgical Dressing: Capillary Refill',
			isTalks: true,
			extTop: true,
			scenario: this,
			extImg: 'CapillaryRefillTime',
			extText: 'Capillary refill is less than 3 seconds.',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PA2bool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PA2bool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action23 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 2,
					quiztop: '5px',
					maxPoints: 250,
					talktext1: 'Patient Assessment',
					talktext2: 'Capillary Refill',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Less than 3 sec',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Greater than 3 sec',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionCatheter() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '370px',
			loadQuiz: true,
			titletext: 'Tunnel Dialysis Catheter Dressing: Dressing',
			isTalks: true,
			extBottom: true,
			scenario: this,
			extText: 'Dressing is clean, dry, and intact.',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PA2bool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PA2bool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action24 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 1000,
					talktext1: 'Patient Assessment',
					talktext2: 'Dressing',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Clean',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Dry',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Intact',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Bleeding present',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionSkin() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '470px',
			loadQuiz: true,
			titletext: 'Tunnel Dialysis Catheter Dressing: Skin',
			isTalks: true,
			extBottom: true,
			scenario: this,
			extText: 'Skin is warm, dry, and color is normal for ethnic group.',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PA2bool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PA2bool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).changNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action25 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 6,
					quiztop: '5px',
					maxPoints: 750,
					talktext1: 'Patient Assessment',
					talktext2: 'Skin',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Warm',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Cold',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Dry',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Wet',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Normal for ethnic group',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Pale',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts2() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0 && this.Action3 === true) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.hideFooter();
			context.scenario.update508Window(Window508Type.Main);
			context.segment1Part5Debrief();
		}
		else if(this.TalkCount === 0 && this.ActionCount !== 0) {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false);
			context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		}
		else if(this.TalkCount !== 0 && this.ActionCount === 0) {
			context.scenario.updateFooter(this.TalkCount.toString(), '0', false, true);
			context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), false, false)
		};
	}

	private checkIfSubMenu2() {
		var context = this;
		if(this.Action21 === true && this.Action22 === true && this.Action23 === true && this.Action24 === true && this.Action25 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			this.Action3 = true;
		};
		context.getFooterCounts2();
	}


	private segment2ActionFail() {
		var context = this;
		this.scenario.gameManager.environment.blurFadeIn();
		this.scenario.displayModalPop(
			null,
            "Your patient has had an adverse event. Please report to the nurses’ station to speak with your charge nurse.",
            () => {
                context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
				context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
				context.scenario.updateFooter('0', '0', true, true);
				context.scenario.hideFooter();
				context.segment2ActionChargeNurse();
            }
        );
	}

	private segment2ActionChargeNurse() {
		var context = this;
		//NEED FAIL ANIM, CHANGE CHAPTERCINEMATICS BELOW TO EACH PLAYER CHARACTER LOOP
		if(this.avatar1) {
			this.playVideoChapter(this.chapterIds.chapterCinematic96, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		} else if (this.avatar2) {
			this.playVideoChapter(this.chapterIds.chapterCinematic97, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		} else if (this.avatar3) {
			this.playVideoChapter(this.chapterIds.chapterCinematic94, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		} else if (this.avatar4) {
			this.playVideoChapter(this.chapterIds.chapterCinematic95, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		}
		setTimeout(() => {
			context.segment2ActionChargeNurseNext();
		}, 1000);
	}

	private segment2ActionChargeNurseNext() {
		var context = this;
		//context.scenario.gameManager.environment.blurFadeIn();
		context.scenario.showRemediation(
			'I would like to discuss Mrs. Chang’s change in condition. Advising a patient to lift small weights with the arm that was recently operated on impedes recovery and may cause further trauma. Please return to Room #5 and begin caring for your patient again.',
			'./assets/images/general/icons/npc-headshots/ChargeNurse.png',
			() => {
				context.scenario.gameManager.environment.blurFadeOut();
				localStorage.setItem('ignoreResumePopup', 'true');
				window.location.reload();
			}
		)
	}
}